import http from 'plugins/axios';

export default {
  getUserBillList(data) {
    return http.get({
      url: '/la/admin/workorder/timeout/task/list',
      data
    });
  },
  getBillTypeList() {
    return http.get({
      url: '/la/admin/user/bill/type'
    });
  },
  reReset(data) {
    return http.post({
      url: '/la/admin/workorder/timeout/task/update',
      data,
      dataType: 'form'
    });
  }
};
